/**
 * Quiz Kit adds to cart via its own script (no theme section rendering).
 * Listen for the official Quiz Kit event and refresh the cart drawer markup + header count
 * (does not open the drawer).
 * @see https://support.quizkitapp.com/advanced-settings/common-code-customizations
 */
(function () {
  function getSectionInnerHTML(html, selector) {
    var node = new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector);
    return node ? node.innerHTML : "";
  }

  function refreshCartSections() {
    var sections = "cart-drawer,cart-bubble";
    var url =
      window.location.pathname +
      "?sections=" +
      sections +
      "&_cb=" +
      Date.now();
    return fetch(url, {
      method: "GET",
      cache: "no-store",
      credentials: "same-origin",
      headers: {
        "X-Requested-With": "XMLHttpRequest",
      },
    })
      .then(function (response) {
        return response.text();
      })
      .then(function (state) {
        var parsedState = JSON.parse(state);
        var toRender = [
          {
            id: "Cart-Drawer",
            section: "cart-drawer",
            selector: ".cart-drawer",
          },
          {
            id: "cart-drawer-toggle",
            section: "cart-bubble",
            selector: ".thb-item-count",
          },
        ];

        toRender.forEach(function (section) {
          var root = document.getElementById(section.id);
          if (!root || !parsedState[section.section]) return;
          var elementToReplace =
            root.querySelector(section.selector) || root;
          elementToReplace.innerHTML = getSectionInnerHTML(
            parsedState[section.section],
            section.selector
          );
        });

        if (typeof CartDrawer !== "undefined" && CartDrawer.instance) {
          CartDrawer.instance.removeProductEvent();
          CartDrawer.instance.notesToggle();
          CartDrawer.instance.termsCheckbox();
        }
      });
  }

  document.addEventListener(
    "quizKitAddToCartSuccess",
    function () {
      refreshCartSections().catch(function () {});
    },
    false
  );

  // Back/forward and bfcache restore stale markup; always revalidate (no cached sections).
  window.addEventListener(
    "pageshow",
    function (event) {
      var fromBFCache = event.persisted;
      var fromHistory = false;
      try {
        var nav = performance.getEntriesByType("navigation")[0];
        fromHistory = nav && nav.type === "back_forward";
      } catch (e) {}
      if (fromBFCache || fromHistory) {
        refreshCartSections().catch(function () {});
      }
    },
    false
  );
})();
